import React from 'react';
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import { ICONS_COURSE_CONTAINER_WIDTH } from '@styles/constants/spacings';
import SectionTitle from '@unicons-base/SectionTitle/SectionTitle';
import CourseMaterialCard from './CourseMaterialCard';

interface CourseMaterialProps {
  courseMaterial: any;
}

const CourseMaterialWrapper = styled.div`
  max-width: ${ICONS_COURSE_CONTAINER_WIDTH};
  margin: 0 auto ${Spacings.SPACING_12B};
  ${mediaQuery.uptoTablet} {
    margin: 0 auto ${Spacings.SPACING_12B};
  }
  ${mediaQuery.uptoMobile} {
    margin: 0 ${Spacings.SPACING_4B} ${Spacings.SPACING_8B};
    padding-bottom: ${Spacings.SPACING_4B};
    border-bottom: 1px solid var(--color-i-icon-dark-button);
  }
`;

const CardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -${Spacings.SPACING_4B};
  ${mediaQuery.uptoTablet} {
    margin: 0;
    padding: 0 ${Spacings.SPACING_4B} 0 0;
  }
`;

const CourseMaterial: React.FC<CourseMaterialProps> = ({ courseMaterial }) => {
  return (
    <CourseMaterialWrapper>
      <SectionTitle title="Course highlights" />
      <CardsWrapper>
        {courseMaterial.map((material, index) => (
          <React.Fragment key={String(`material-${index}`)}>
            <CourseMaterialCard icon={material.icon} title={material.title} />
          </React.Fragment>
        ))}
      </CardsWrapper>
    </CourseMaterialWrapper>
  );
};

CourseMaterial.displayName = 'CourseMaterial';

export default CourseMaterial;
